/**
 * Copyright (c) 2021 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	robin herrmann - itemis AG
 *
 */

import { PreferenceStore } from "../../services/preference-store";

export const ERROR_COLOR = PreferenceStore.INSTANCE.theme.model.validation.errorColor;
export const WARNING_COLOR = PreferenceStore.INSTANCE.theme.model.validation.warningColor;
export const MARKER = "\uf06a";

export interface Validation {
  displayDiagnostics(): void;
}
